<template>
	<div class="word_book_contain">
    <!-- 头部 -->
    <div class="home_header mb-189">
			<div class="list_every home_header_main h237 pd-16 box-s">
        <div class="flex">
          <img class="book_img" :src="data.book_cover" alt="">

          <div class="ml-16 pt-2 flex1">
            <div class="flex flex-jus">
              <div class="c1 fz-14 fw-500 wh_138_40 text-hide2">{{data.book_name}}</div>
              <div class="flexs plan_btn flex-center" @click="getAdjust">调整计划 <img class="wh_6_8 ml-4" src="../../assets/img/icon/gray_right_arrow_icon.png" alt=""> </div>
            </div>
            <div class="mtb-12-8 c3 fz-12 l-h-12">学习进度：{{data.current_progress}}/{{data.word_base}}</div>
            <div><van-progress color="#497CFF" :percentage="percentage" :show-pivot="false"/></div>
          </div>
        </div>

        <!-- 数据 -->
        <div class="pt-55 flexs pr text-center">
          <img class="word_bg" src="../../assets/img/bg/word_book_bg.png" alt="">
          <div class="flex1">
            <div class="fz-14 c1 mb-17 l-h-14">需新学</div>
            <div class="c0 fw-700 word_data_num">{{data.day_study_plan}}</div>
          </div>

          <div class="word_line"></div>

          <div class="flex1">
            <div class="fz-14 c1 mb-17 l-h-14">需复习</div>
            <div class="c0 fw-700 word_data_num">{{data.day_review_plan}}</div>
          </div>

          <div class="word_line"></div>

          <div class="flex1">
            <div class="fz-14 c1 mb-17 l-h-14">剩余天数</div>
            <div class="c0 fw-700 word_data_num">{{data.time_remaining}}</div>
          </div>
        </div>
      </div>
		</div>

    <!-- 下部日历 -->
    <div class="list_every mlr-16">
      <div class=" cale_con flex pt-24 mrl-23-25 text-center box-s">
        <div v-for="(item, index) in dateList" :key="index" class="flex1" >
          <div class="fz-10 c3 fw-500 mb-8">{{item.week}}</div>
          <div class="fz-12 c1 pr l-h-27 m0-auto" :class="{'today_sty': item.is_today}">
            {{item.day}}

            <div class="blue_cicle" v-if="item.is_select"></div>
          </div>
        </div>
      </div>

      <div class="p9-25-10-23 c0 fz-12 text-center" @click="lookCander">
        查看学习日历
      </div>
    </div>

    <div class="btn_contain">
      <div class="blue_btn" @click="getStudy">
        立即学习
      </div>
    </div>
    <loading :loadFlag="loadFlag"></loading>
	</div>
</template>
<script>
	import { getEnglishBookPlan, resetEnglishStudyPlan } from '@/api/api.js'
	import loading from "@/components/loading"
	export default {
		components: {
      loading
		},
		data() {
			return {
			  dateList: [
          {
            week: '日',
            day: '',
            is_today: false,
            is_select: false,
          },
          {
            week: '一',
            day: '',
            is_today: false,
            is_select: false
          },
          {
            week: '二',
            day: '',
            is_today: false,
            is_select: false
          },
          {
            week: '三',
            day: '',
            is_today: false,
            is_select: false
          },
          {
            week: '四',
            day: '',
            is_today: false,
            is_select: false
          },
          {
            week: '五',
            day: '',
            is_today: false,
            is_select: false
          },
          {
            week: '六',
            day: '',
            is_today: false,
            is_select: false
          }
        ],
        data: {},
        percentage: 0,
        loadFlag: false
			};
		},
		created() {
      
      this.initData()
		},
    
		methods: {
      // 初始化日历时间
      getCalendar(){
        const today = new Date()
        const DateTime = today.getTime()
        const t_day =  today.getDay()
        const time = 24 * 60 * 60 * 1000
        
        this.dateList.forEach((item, index) => {
          item.is_today = false
          item.is_select = false

          const day = new Date(DateTime + time * (index - t_day))
          item.day = day.getDate()
          if(this.data.date.filter(i => i.day.split('-')[2] == item.day).length != 0){
            item.is_select = true
          }

          if(t_day == index){
            item.is_today = true
            item.is_select = false
          }

          
          
        })
      },

      async initData(){
        this.loadFlag = true
        const res = await getEnglishBookPlan()
        this.loadFlag = false
        if(res.code == 1000){
          this.data = res.data
          this.percentage = (this.data.current_progress / this.data.word_base) * 100
          console.log(this.data.current_progress, this.data.word_base,this.percentage,98)
          this.getCalendar()
        }else {
					 this.$toast(res.msg)
				}
      },

      // 查看学习日历
      lookCander(){
        this.$router.push('/calendar')
      },

      getStudy(){
        if(this.data.select_book_status == 2){
          this.$router.push({ path:'/reciteword', query: { plan_id: this.data.plan_id } })
        } else if(this.data.select_book_status == 3){
          this.$dialog.confirm({
            title: '提示',
            message:
              '此书籍已学完,是否重新学习？',
          })
            .then(async() => {
              const res = await resetEnglishStudyPlan({ plan_id: this.data.plan_id })
              if(res.code == 1000){
                this.$router.push({ path:'/reciteword', query: { plan_id: this.data.plan_id } })
              }else {
                this.$toast(res.msg)
              }
            })
            .catch(() => {});
        } else if(this.data.select_book_status == 4){
          this.$toast('今日背单词已完成')
        }
        
      },

      getAdjust(){
        const { english_book_id, book_name, word_base, book_cover, current_progress, day_study_plan, day_review_plan,plan_id } = this.data
        this.$router.push({ path: '/adjustplan', query: { data: JSON.stringify({ id: english_book_id, book_name, word_base, book_cover, current_progress, day_study_plan, day_review_plan,plan_id }), word: 1 } })
      }
    }
	};
</script>
<style lang="less" scoped>
  @import '@/assets/css/home.less';
</style>
